import { render } from "./Location.vue?vue&type=template&id=79d35f01"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
script.render = render

export default script